import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PromotionTypeCreatePage } from './promotion-type-create.page';

const routes: Routes = [
  {
    path: '',
    component: PromotionTypeCreatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PromotionTypeCreatePageRoutingModule {}
